import store from "../redux/store";

const TENANT_ID = "tenantId";
const TENANT_INFO = "tenantInfo";
const TOKEN = "accessToken";
const REFRESH_TOKEN = "refreshToken";
const USER_INFO = "userInfo";
const TENANT_IMAGES = "tenantImages";
const THEME_COLOR = "themeColor";

// TENANT ID
export function setTenantID(tenantId) {
  localStorage.setItem(TENANT_ID, tenantId);
}
export function getTenantID() {
  let tenantId = localStorage.getItem(TENANT_ID);
  const state = store.getState();
  const portalViewTenant = state.auth.portalViewTenant;

  if (Boolean(portalViewTenant)) {
    tenantId = portalViewTenant;
  }

  return tenantId;
}

export function deleteTenantId() {
  localStorage.removeItem(TENANT_ID);
}

export function setTenant(tenant) {
  localStorage.setItem(TENANT_INFO, JSON.stringify(tenant));
}

export function getTenant() {
  return JSON.parse(localStorage.getItem(TENANT_INFO));
}

export function deleteTenant() {
  return localStorage.removeItem(TENANT_INFO);
}

// TOKEN
export function setToken(token) {
  localStorage.setItem(TOKEN, token);
}

export function getToken() {
  return localStorage.getItem(TOKEN);
}

export function deleteToken() {
  localStorage.removeItem(TOKEN);
}

export function checkTokenExists() {
  try {
    return !!getToken(); // Converts value to boolean (true if token exists, false if null/undefined)
  } catch (error) {
    console.error("Error while checking token exists:", error);
    return false; // Return false in case of an error
  }
}

// REFRESH TOKEN

export function setRefreshToken(token) {
  localStorage.setItem(REFRESH_TOKEN, token);
}

export function getRefreshToken(token) {
  return localStorage.getItem(REFRESH_TOKEN);
}

export function deleteRefreshToken() {
  localStorage.removeItem(REFRESH_TOKEN);
}

export function checkRefreshToken() {
  if (getRefreshToken()) {
    return true;
  } else {
    return false;
  }
}

// USER DETAILS
export function setUser(userDetails) {
  localStorage.setItem(USER_INFO, JSON.stringify(userDetails));
}

export function getUser() {
  return JSON.parse(localStorage.getItem(USER_INFO));
}

export function deleteUser() {
  localStorage.removeItem(USER_INFO);
}

//TENANT_RELATED_IMAGES

export function setTenantImages(images) {
  localStorage.setItem(TENANT_IMAGES, JSON.stringify(images));
}

export function getTenantImages() {
  return JSON.parse(localStorage.getItem(TENANT_IMAGES));
}

export function deleteTenantImages() {
  localStorage.removeItem(TENANT_IMAGES);
}
export function setThemeColor(color) {
  localStorage.setItem(THEME_COLOR, JSON.stringify(color));
}

export function getThemeColor() {
  const color = localStorage.getItem(THEME_COLOR);
  return color ? JSON.parse(color) : null;
}

export function deleteThemeColor() {
  localStorage.removeItem(THEME_COLOR);
}
